import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/firstRecharge/calendarFR3.png'
import _imports_1 from '@/assets/firstRecharge/gitfBoxFR3.png'


const _hoisted_1 = { class: "dayListFirst" }
const _hoisted_2 = { class: "dayImage" }
const _hoisted_3 = {
  key: 0,
  class: "dateText"
}
const _hoisted_4 = { class: "date-year" }
const _hoisted_5 = { class: "date-month" }
const _hoisted_6 = { class: "date-day" }
const _hoisted_7 = {
  key: 1,
  class: "dayText"
}
const _hoisted_8 = { class: "toptext" }
const _hoisted_9 = { class: "toptext-amount" }
const _hoisted_10 = { class: "toptext" }
const _hoisted_11 = { class: "toptext-amount" }
const _hoisted_12 = { style: {"color":"rgb(190 220 255)","font-weight":"600"} }
const _hoisted_13 = { style: {"color":"#ffe0a1","font-weight":"600"} }
const _hoisted_14 = {
  key: 0,
  class: "claimBtn"
}
const _hoisted_15 = {
  key: 1,
  class: "right-texts"
}
const _hoisted_16 = {
  key: 0,
  class: "status-badge status-norewards"
}
const _hoisted_17 = {
  key: 1,
  class: "status-badge status-pending"
}
const _hoisted_18 = {
  key: 2,
  class: "status-badge status-completed"
}
const _hoisted_19 = {
  key: 3,
  class: "status-badge status-norewards"
}
const _hoisted_20 = {
  key: 4,
  class: "status-badge status-norewards"
}

import { } from 'vue';
import { checkDate, formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';


export default /*@__PURE__*/_defineComponent({
  __name: 'dayListFirst',
  props: {
    day: {
        type: Number
    },
    valueOne: {
        type: Number
    },
    valueTwo: {
        type: Number
    },
    currenyLable: {
        type: Boolean
    },
    labelOne: {
        type: String
    },
    labelTwo: {
        type: String
    },
    time: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    returnTurnover: {
        type: Boolean,
        default: false
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
    isShowHistory: {
        type: Boolean,
        default: false
    }
},
  emits: ['getClaim'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit

const getMonthName = (timestamp: number) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const lang = localStorage.getItem('lang') === 'pt' ? 'pt-BR' : 'en-US';
    let monthStr = date.toLocaleString(lang, { month: 'short' }).replace('.', '');
    return monthStr.charAt(0).toUpperCase() + monthStr.slice(1);
}

const clickOnButton = () => {
    emits('getClaim')
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, {
      class: _normalizeClass(['cardContainer', __props.isShowHistory ? 'historyMode' : ''])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "5",
          class: "dayColumn"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                class: "calendarImage",
                src: _imports_0,
                alt: ""
              }, null, -1)),
              (props.time)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatUnixTimestamp)(props.time)?.split(' ')[0]?.split('-')[0]), 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(getMonthName(props.time)), 1),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(formatUnixTimestamp)(props.time)?.split(' ')[0]?.split('-')[2]), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(props.day), 1))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "14",
          style: {"padding":"0 10px","display":"flex","align-items":"center"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: "24" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_row, null, {
                  default: _withCtx(() => [
                    (__props.isShowHistory ? true : _unref(checkDate)(_unref(formatUnixTimestamp)(props.time)) == 0)
                      ? (_openBlock(), _createBlock(_component_van_col, {
                          key: 0,
                          span: "24"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_van_row, { class: "topData" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_col, {
                                  span: "12",
                                  class: "topCol"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('activity.available')), 1),
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formatCurrency)(__props.availableAmount)), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_van_col, {
                                  span: "12",
                                  class: "topCol"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('activity.givenAmount')), 1),
                                    _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(formatCurrency)(__props.givenAmount)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_van_col, {
                      span: "24",
                      style: {"padding-left":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(['middle-texts', props.activityStatus == 0 || props.activityStatus == 11 || props.activityStatus == 2 ? 'middle-pending' : ''])
                        }, [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t(props.labelOne || '')) + ":" + _toDisplayString(props.currenyLable ? 'R$' : '') + " " + _toDisplayString(props.valueOne) + _toDisplayString(props.currenyLable ? '' : '%'), 1),
                          _createElementVNode("p", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t(props.labelTwo || '')) + ": ", 1),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(props.valueTwo) + "X", 1)
                          ])
                        ], 2)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "5",
          style: {"padding-left":"10px","display":"flex","align-items":"center","justify-content":"center"}
        }, {
          default: _withCtx(() => [
            (__props.isShowHistory ? false : __props.activityStatus == 0 && _unref(checkDate)(_unref(formatUnixTimestamp)(props.time)) == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "click_btn",
                    onClick: clickOnButton
                  }, _toDisplayString(_ctx.$t('activity.click')), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                  _cache[1] || (_cache[1] = _createElementVNode("img", {
                    src: _imports_1,
                    class: "status-gift-icon",
                    alt: ""
                  }, null, -1)),
                  (props.activityStatus == 0 && __props.returnTurnover)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
                    : (props.activityStatus == 0 || props.activityStatus == 11)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t('activityStatus.pending')), 1))
                      : (props.activityStatus == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('activityStatus.completed')), 1))
                        : (props.activityStatus == 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('activityStatus.noRewards')), 1))
                          : (props.activityStatus == 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('activity.overdue')), 1))
                            : _createCommentVNode("", true)
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}
}

})